import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-height: 400px;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--beam-color-neutral-n400);
  border-top: none;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: white;
  padding: 12px 0;
  row-gap: 16px;
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 12px;
  justify-content: flex-start;

  &.secondItem {
    margin-top: 8px;
  }
`;

export const Header = styled.span`
  color: ${beam.neutral.n600};

  margin-bottom: 0;
  white-space: nowrap;
  padding-left: 8px;

  font-style: normal;
  font-weight: normal;
  font-size: 10px;
`;
export const StyledOption = styled.div`
  display: flex;
  font-style: normal;
  width: 100%;
  font-weight: normal;
  user-select: none;
  align-items: flex-start;
  flex-direction: row;
  margin-top: 4px;
  font-size: 12px !important;
  padding: 8px 12px 0;
  justify-content: flex-start;
  text-align: start;
  cursor: pointer;
  color: ${beam.neutral.n800};

  :hover {
    // Add here css changes when hovered
  }
  * {
    font-size: 12px !important;
    padding: 0;
    font-weight: 400;
  }
  & .text {
    font-size: 12px !important;
    font-weight: 600;
    background: transparent;
    margin: 0;
    padding: 0;
  }
  :hover {
    background: ${beam.background.hover};
  }
`;

interface IOption {
  isActive?: boolean;
}
export const StyledOptionAutoComplete = styled(StyledOption)<IOption>`
  :hover {
    background: ${beam.background.hover};
  }
  background: ${({ isActive }) =>
    isActive ? beam.background.hover : 'transparent'};
`;

export const Image = styled.img`
  width: 18px;
  height: 18px;
  border-radius: 2px;
  object-fit: cover;
  margin-right: 16px;
  &.defaultImage {
    border: none;
  }
`;
export const Margin = styled.div`
  width: 24px;
`;
export const SerialEmpty = styled.span`
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  box-sizing: border-box;
  color: #c1c4d6;

  /* Inside auto layout */
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 0;
  offset-start: 6px;
`;
export const SetMaxWeight = styled.div`
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
